import { render, staticRenderFns } from "./CourseHelpApp.vue?vue&type=template&id=4c638a45&"
import script from "./CourseHelpApp.vue?vue&type=script&lang=js&"
export * from "./CourseHelpApp.vue?vue&type=script&lang=js&"
import style0 from "./CourseHelpApp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports